/* ------------------------------------------------------------
 * sominix-faq-collapsed.js
 * The Pro product sections render the first FAQ with the `open`
 * attribute. This closes it on load so every question starts
 * collapsed. Done in JS rather than editing the section markup
 * so it can be removed by deleting one <script> tag.
 * ------------------------------------------------------------ */
(function () {
  function collapseFaqs() {
    document.querySelectorAll('details.sxp-faq[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapseFaqs);
  } else {
    collapseFaqs();
  }
})();
